export function normalizeBarcode(value?: string | null): string {
  if (!value) return '';

  const digitsOnly = value.replace(/\D/g, '');
  if (!digitsOnly) return '';

  const withoutLeadingZeroes = digitsOnly.replace(/^0+/, '');
  return withoutLeadingZeroes || '0';
}
